import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PerfHelpComponent} from './perf-help.component';
import {ModalModule} from "ngx-bootstrap/modal";
import {PerfHelpModalModule} from "../perf-help-modal/perf-help-modal.module";


@NgModule({
  declarations: [PerfHelpComponent],
  imports: [
    CommonModule,
    ModalModule,
    PerfHelpModalModule
  ],
  exports: [PerfHelpComponent]
})
export class PerfHelpModule {
}
